import { Breadcrumb } from "../components/Breadcrumbs/Breadcrumbs";
import { SanityPage, SanitySiteHierarchyItem } from "../model/common";
import { urlForDocument } from "../urls";

export const getBreadcrumbs = (
  hierarchy: SanitySiteHierarchyItem[] | null,
  currentPage: SanityPage,
  options: { parentBreadcrumbs?: Breadcrumb[]; maxLevels?: number } = {}
): Breadcrumb[] => {
  const paths = getPageHierarchyItems(hierarchy, currentPage);
  const breadcrumbs = paths.map((item, idx) => ({
    title:
      idx === paths.length - 1 || !item.label
        ? item.internalLink.title
        : item.label,
    href: urlForDocument(item.internalLink)
  }));
  return [...(options.parentBreadcrumbs ?? []), ...breadcrumbs].slice(
    options.maxLevels ? -options.maxLevels : 0
  );
};

const getPageHierarchyItems = (
  hierarchy: SanitySiteHierarchyItem[] | null,
  currentPage: SanityPage
): SanitySiteHierarchyItem[] => {
  const currPageItem = { internalLink: currentPage, content: [], label: "" };
  if (!hierarchy) {
    return [currPageItem];
  }
  const paths = getAllPagePaths(hierarchy);
  return paths.get(currentPage._id) ?? [currPageItem];
};

const getAllPagePaths = (
  hierarchy: SanitySiteHierarchyItem[],
  paths: SanitySiteHierarchyItem[] = []
): Map<string, SanitySiteHierarchyItem[]> => {
  const result = new Map<string, SanitySiteHierarchyItem[]>();

  for (const item of hierarchy) {
    const currPath: SanitySiteHierarchyItem[] = [...paths, item];

    // Store the path for this page.
    result.set(item.internalLink._id, [...paths, item]);

    // Recurse into children.
    if (item.content?.length) {
      const childResults = getAllPagePaths(item.content, currPath);
      childResults.forEach((p, id) => result.set(id, p));
    }
  }

  return result;
};
